import EventEmitter from 'eventemitter3';
const eventEmitter = new EventEmitter();
export default eventEmitter;